<script>
import { mapGetters } from "vuex";

import Filtro from "./Panel.vue";
import Slider from "./DuracionSlider.vue";
import Placeholder from "../Placeholder/Filtros/Duracion.vue";

export default {
  components: { Filtro, Slider, Placeholder },
  computed: {
    ...mapGetters([
      "isPreloader",
      "getFiltroDuracionMin",
      "getFiltroDuracionMax"
    ])
  },
  methods: {
    clear() {
      this.$refs.slider.clear();
    }
  }
};
</script>

<template>
  <div v-if="getFiltroDuracionMin < getFiltroDuracionMax">
    <filtro v-if="!isPreloader" heading="Noches" icono="weather-night" :total="false">
      <slider ref="slider"></slider>
    </filtro>
    <placeholder v-else></placeholder>
  </div>
</template>
